import React, { useEffect, useState } from 'react'
import AuthHeader from '../../components/Navbar/AuthHeader'
import { Link, useNavigate } from 'react-router-dom'
import successImg from '../../assets/img/icon/success_gif.gif'
import { useSelector } from 'react-redux';

function KycSuccess() {
    const navigate = useNavigate();
    const userDetailsString = localStorage.getItem("userDetails");
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    let userDetails = null;
    try {
        userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
    } catch (error) {
        // console.error("Error parsing userDetails from localStorage:", error);
    }    

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            setIsLoggedIn(true);
        }
    }, [userDetails]);

    const handleSubmit = (e) => {
        e.preventDefault()
        navigate('/login');
    }
    return (
        <div style={{background: '#13053A',minHeight: '100vh'}}>
            <AuthHeader />
            <div className="auth__container padding__tb__30">
                <div className='auth__container__box'>
                    <h3>Congratulations!</h3>
                    <p className='success-page auth__text'>KYC details updated successfully!</p>
                    <div className='auth__container__form w-full'>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-lg-12 text-center">
                                    <img src={successImg} className='img-fluid' alt="" style={{ maxHeight: '225px', }} />
                                </div>
                            </div>
                            <div className='form__group mb-5'>
                                {isLoggedIn ? (
                                    <Link to="/user/dashboard" className='btn btn__block'>Go to Dashboard</Link>
                                ):(
                                    <Link to="/login" className='btn btn__block'>Proceed to Login</Link>
                                )}
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default KycSuccess